(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/assets/javascripts/views/lists.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/assets/javascripts/views/lists.js');
"use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.map_of_winners.views.Lists = Marionette.CollectionView.extend({
    CONSTANTS: svs.map_of_winners.data.constants,
    className: 'hide mow-list bg-andra-chansen f-inverted margin-bottom-2 panel border-opacity-white-40 col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1',
    childView: svs.map_of_winners.views.List,
    childViewOptions() {
      return {
        collection: this.mainCollection
      };
    },
    initialize() {
      this.mainCollection = this.collection;
      this.collection = this.collection.mergeByKeyValue(['winType'], null, true);
    }
  });
})(Backbone, _, svs);

 })(window);